<h1 class="text-center">Your Enterprise Plan</h1>
<div class="description-container">
	<span>
		Please
		<button class="link interactive" type="button" (click)="intercomService.show()">contact</button>
		your account manager to adjust your plan.
	</span>
</div>
